import React from "react";
import styles from "./styles.scss";
import General from "./General";
import { connect } from "react-redux";

import Address from "./Address.js";
import AccountWebLinks from "./AccountWebLinks";
import ContactWebLinks from "./ContactWebLinks";
import AdditionalContacts from "./AdditionalContacts/AdditionalContacts";
//import Contacts from "Portal/NewPortal/Sections/Profile/View/ProfileInfo/Contacts/Contacts";
import CustomFieldsPanel from "./CustomFieldsPanel";

import { getters } from "Portal/NewPortal/Sections/Profile/model";

import Loading from "ui-kit/Loading";

import {
  getFieldOptions,
  isViewingAsAccount,
  showAccountContacts,
  showAdditionalContacts
} from "../../selectors";

const decorate = connect(state => ({
  data: getters.data(state),
  loading: getters.loading(state),
  updatedFieldValues: getters.updatedFieldValues(state),
  lockedFieldIds: getters.lockedFieldIds(state),
  visibleFieldIds: getters.visibleFieldIds(state),
  isViewingAsAccount: isViewingAsAccount(state),
  showAccountContacts: showAccountContacts(state),
  showAdditionalContacts: showAdditionalContacts(state),
  fieldOptions: getFieldOptions(state)
}));

const Layout = ({
  loading,
  data = {},
  updatedFieldValues = {},
  lockedFieldIds,
  visibleFieldIds,
  showAdditionalContacts,
  // showAccountContacts,
  isViewingAsAccount,
  fieldOptions,
  //
  canCreateContacts,
  canUpdateContacts,
  canDeleteContacts
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.leftContainer}>
        {loading ? (
          <Loading />
        ) : (
          <>
            <General
              {...{
                data,
                updatedFieldValues,
                lockedFieldIds,
                visibleFieldIds,
                fieldOptions,
                isViewingAsAccount
              }}
            />
            {!isViewingAsAccount && (
              <Address
                {...{
                  data,
                  updatedFieldValues,
                  fieldOptions,
                  lockedFieldIds,
                  visibleFieldIds
                }}
              />
            )}
            <CustomFieldsPanel />
            {!isViewingAsAccount && showAdditionalContacts ? (
              <AdditionalContacts
                canCreateContacts={canCreateContacts}
                canUpdateContacts={canUpdateContacts}
                canDeleteContacts={canDeleteContacts}
              />
            ) : null}
            {/*
        {isViewingAsAccount && showAccountContacts ? (
          <Contacts
            canCreateContacts={canCreateContacts}
            canUpdateContacts={canUpdateContacts}
            canDeleteContacts={canDeleteContacts}
          />
        ) : null}
         */}
          </>
        )}
      </div>
      <div className={styles.rightContainer}>
        {loading ? (
          <Loading />
        ) : (
          <>
            {isViewingAsAccount ? (
              <AccountWebLinks
                {...{
                  data,
                  updatedFieldValues,
                  lockedFieldIds,
                  visibleFieldIds
                }}
              />
            ) : (
              <ContactWebLinks
                {...{
                  data,
                  updatedFieldValues,
                  lockedFieldIds,
                  visibleFieldIds
                }}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default decorate(Layout);
